
/*global AOS*/

import AOS from 'aos';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper/core';

var storeSlider = function() {
  const swiper = new Swiper('.store-slider', {
    slidesPerView: 1,
    spaceBetween: 32,

    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
      disabledClass: 'opacity-0 pointer-events-none',
    },
    on: {
      init: function () {
        AOS.refresh();
      },
    },
  });
}

var musicSlider = function() {
  const swiper = new Swiper('.music-slider', {
    slidesPerView: 2,
    spaceBetween: 32,

    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  
    navigation: {
      nextEl: '.button-next-music',
      prevEl: '.button-prev-music',
      disabledClass: 'opacity-0 pointer-events-none',
    },
    on: {
      init: function () {
        AOS.refresh();
      },
    },
  });
}

export default {
  init() {
    storeSlider();
    musicSlider();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
